import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=3d019866&scoped=true"
import script from "./emoji.vue?vue&type=script&lang=js"
export * from "./emoji.vue?vue&type=script&lang=js"
import style0 from "./emoji.vue?vue&type=style&index=0&id=3d019866&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d019866",
  null
  
)

export default component.exports